import { Injectable } from '@angular/core'
import { BaseSiteService } from '@spartacus/core'
import { CurrencyService } from '@spartacus/core'
import { SiteContext } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

export const AU = 'au'
export const NZ = 'nz'
export const AUD = 'AUD'
export const NZD = 'NZD'
export const AUSITE = 'asaleocare-au'
export const NZSITE = 'asaleocare-nz'

export function baseSiteToCountry(baseSite: string): string {
  if (baseSite === AUSITE) {
    return AU
  } else if (baseSite === NZSITE) {
    return NZ
  }
}

@Injectable({ providedIn: 'root' })
export class CustomContextService implements SiteContext<string> {
  constructor(
    protected baseSiteService: BaseSiteService,
    protected currencyService: CurrencyService
  ) {}

  getActive(): Observable<string> {
    return this.baseSiteService.getActive().pipe(map(baseSiteToCountry))
  }

  setActive(country: string): void {
    country = country?.toLowerCase()
    if (country === NZ) {
      this.baseSiteService.setActive(NZSITE)
      this.currencyService.setActive(NZD)
    } else {
      this.baseSiteService.setActive(AUSITE)
      this.currencyService.setActive(AUD)
    }
  }

  getAll(): Observable<string[]> {
    return this.baseSiteService
      .getAll()
      .pipe(map((baseSites) => baseSites.map((baseSite) => baseSiteToCountry(baseSite.name))))
  }
}
